export default import.meta.ROLLDOWN_FILE_URL_Ekh_rW7dAR6uL_8ap9NdGQ